import {Grid} from '@logistics-frontend/blocks'
import {FormControlLabel} from '@logistics-frontend/blocks/lpc/form-control-label'
import {GridHeader} from '@logistics-frontend/blocks/lpc/grid-header'
import {Radio, RadioGroup} from '@logistics-frontend/blocks/lpc/radio'
import {useRequirementValue} from '@yandex-taxi/react-integration-api'
import clsx from 'clsx'
import React, {useCallback} from 'react'

import {useRequirementGoalCallback} from '../../../../shared/metrika'
import {useClasses} from '../classes'
import {useDefaultCargoTypeRequirement} from './hooks'
import {Props} from './types'

// маппим значения для метрики
const ValueNames: Record<string, string> = {
  van: 'Small',
  lcv_m: 'Medium',
  lcv_l: 'Large',
}

const CargoTypeRequirement: React.FC<Props> = ({requirement, tariff}) => {
  const type = requirement.select?.type
  const classes = useClasses()
  const [{value, touched, error}, {setValue, setTouched}] = useRequirementValue(requirement.name)
  const goalCallback = useRequirementGoalCallback(tariff, requirement.name)
  const options = requirement.select?.options
  const changeHandler = useCallback(
    (_, stringValue: string | null) => {
      // fixme тут не правильная логика выбора значения
      //       нужно в радио кнопку писать поле name и по нему искаться value (value может быть разных типов)
      //       это в целом для всех селектов, а не только тут
      const value = type === 'number' ? parseInt(stringValue, 10) : stringValue

      if (value) {
        setValue(value)
        setTouched(true)
        goalCallback(ValueNames[value] || value)
      }
    },
    [goalCallback, setTouched, setValue, type],
  )

  useDefaultCargoTypeRequirement(requirement.name, options)

  if (!options) {
    return null
  }

  const imageClassMap = options.reduce((acc, option) => {
    acc[classes[`image_${option.name}`]] = option.value === value
    return acc
  }, {})

  return (
    <Grid spacing={1} container>
      <GridHeader className={classes.boldTitle} xs={12} item>
        {requirement.label}
      </GridHeader>
      <Grid alignItems="center" className={classes.container} container item>
        <Grid md={5} sm={12} container item>
          <RadioGroup onChange={changeHandler} value={`${value}`}>
            {options.map(option => (
              <FormControlLabel
                key={option.name}
                className={classes.formControlLabel}
                control={<Radio color="primary" error={!!(touched && error)} />}
                label={
                  <Grid>
                    {option.title}
                    <Grid className={classes.subtitle} xs={12} item>
                      {option.label}
                    </Grid>
                  </Grid>
                }
                value={`${option.value}`}
              />
            ))}
          </RadioGroup>
        </Grid>
        <Grid className={clsx(classes.image, imageClassMap)} container item xs />
      </Grid>
    </Grid>
  )
}

export default CargoTypeRequirement
